import { Component, Inject, Input, OnInit } from '@angular/core';
import { Project } from 'src/app/model/project/project';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { RequestService } from 'src/app/services/request.service';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { SnackService } from 'src/app/services/snack.service';
import ProductAsset from 'src/app/model/product-asset';
import { SubProject } from '../../model/project/sub-project';
import { ContactOption } from '../send-thank-you-mail/contact-option';
import { Email } from 'src/app/model/email';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { StringHelper } from 'src/app/helpers/string-helper';

@Component({
  selector: 'send-quotation-mail',
  templateUrl: './send-quotation-mail.component.html',
  styleUrls: ['./send-quotation-mail.component.scss'],
})
export class SendQuotationMailComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  inputSubProject: SubProject;

  @Input()
  inputProject: Project;

  quotationContact: ContactOption;

  contactOptions: ContactOption[];
  selectedContacts: ContactOption[];

  assetOptions: ProductAsset[];
  selectedAssets: ProductAsset[] = [];

  init = false;
  sending = false;

  constructor(
    public dialogRef: MatDialogRef<SendQuotationMailComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private requestService: RequestService,
    private snackService: SnackService
  ) {
    super();
    const quotationSendEmail = new Email();
    quotationSendEmail.email = 'offerte@inpress.be';
    this.quotationContact = new ContactOption(
      null,
      false,
      'Offerte',
      'Inpress',
      [quotationSendEmail]
    );
    this.inputProject = data.project;
    this.inputSubProject = data.subProject;
  }

  ngOnInit() {
    this.loadProject();
  }

  loadProject() {
    this.addSubscription(
      this.requestService.getNormal('/projects/' + this.inputProject.id),
      (res) => {
        this.inputProject = res;
        if (res.subProjects != null) {
          for (let subProject of res.subProjects) {
            if (subProject.id === this.inputSubProject.id) {
              this.inputSubProject = subProject;
              break;
            }
          }
        }
        this.constructEmailOptions();
        this.init = true;
      }
    );
  }

  constructEmailOptions() {
    this.selectedContacts = [].concat(
      this.inputProject.projectContacts.map((pc) =>
        ContactOption.fromContact(pc.contact, pc.projectManager)
      )
    );
    this.contactOptions = []
      .concat(
        this.inputProject.projectContacts
          .filter(
            (pc) => !this.selectedContacts.some((sc) => sc.id === pc.contact.id)
          )
          .map((pc) =>
            pc.company.contacts.map((c) => ContactOption.fromContact(c, false))
          )
          .reduce(concat, [])
      )
      .concat(this.selectedContacts);
    this.contactOptions.push(this.quotationContact);
  }

  compareEntities(pa1: any, pa2: any) {
    return pa1 != null && pa2 != null && pa1.id === pa2.id;
  }

  closeDialog() {
    this.dialogRef.close(null);
  }

  sendMail() {
    if (!this.canSendMail()) {
      return;
    }
    let body = {
      contacts: this.selectedContacts
        .filter((c) => c !== this.quotationContact)
        .map((c) => c.id),
      sendToQuotationAddress: this.selectedContacts.includes(
        this.quotationContact
      ),
    };
    this.sending = true;
    this.addSubscription(
      this.requestService.post(
        body,
        '/subprojects/sendQuotationEmail/' + this.inputSubProject.id //TODO set correct endpoints
      ),
      (result) => {
        if (result != null && result.success == null) {
          if (CollectionHelper.isPopulated(result.failedEmailAddresses)) {
            this.snackService.showWarning(
              'Offerte kon niet verstuurd worden naar volgende e-mailadressen: ' +
                StringHelper.join(result.failedEmailAddresses, ', ')
            );
          } else {
            this.snackService.showSuccess('Offerte succesvol verstuurd');
          }
          this.dialogRef.close(result.registeredAction);
        } else if (result != null && result.success === false) {
          this.snackService.showError(result.message);
        }
        this.sending = false;
      },
      (err) => {
        this.sending = false;
      }
    );
  }

  canSendMail(): boolean {
    if (this.selectedContacts == null || this.selectedContacts.length === 0) {
      return false;
    }
    if (
      this.selectedContacts.some(
        (c) => c.emails == null || c.emails.length === 0
      )
    ) {
      this.snackService.showWarning(
        'Gelieve enkel ontvangers te selecteren die een e-mailadres hebben'
      );
      return false;
    }
    return true;
  }
}

const concat = (x, y) => x.concat(y);
